module.exports = __webpack_public_path__ + "img/blue-tooth.46b2dfab.png";